// Types
import { TokenApiDataApiResponseType } from '../types/token-api-data-api-response.type';
// Utilities
import { fetchCustomerAuthorizationDataService } from '../services/token.service';

const fetchCustomerAuthorizationDataResolver = async (
  token: string
): Promise<[TokenApiDataApiResponseType] | [null, true]> => {
  const [response] = await fetchCustomerAuthorizationDataService(token);

  return response?.accessToken ? [response] : [null, true];
};

export { fetchCustomerAuthorizationDataResolver };
